import Chest from 'components/Chest';
import Uploader from 'components/Uploader';
import AccountSuspension from 'components/AccountSuspension';
import { useEffect, useState } from 'react';
import { useGetAccountQuery } from 'store/api';
import { useModal } from 'hooks/useModal';
import { useTranslation } from 'react-i18next';
import { ReactComponent as ChestLogo } from 'assets/images/chest-logo.svg';
import { useCreateWishlistSignupMutation } from 'store/api';
import { useSelector } from 'react-redux';

export default function MyChest() {
  const { t } = useTranslation();
  const { data: account, isSuccess: isSuccessAccount } = useGetAccountQuery('Account', {
    refetchOnMountOrArgChange: true,
  });
  const [percentageUsed, setPercentageUsed] = useState(0);
  const { onOpen: openWishlistModal } = useModal('WishlistModal');
  const { user } = useSelector((state) => state.auth);
  const [createWishlistSignup, { isLoading }] = useCreateWishlistSignupMutation();
  const [isRegistered, setIsRegistered] = useState(false);

  useEffect(() => {
    if (isSuccessAccount) {
      if (account.has_subscription) return setPercentageUsed(0);
      setPercentageUsed((account.used_seconds / account.total_seconds) * 100);
    }
  }, [account?.has_subscription]);

  // Check if user is already registered in wishlist from localStorage
  useEffect(() => {
    const registeredEmails = JSON.parse(localStorage.getItem('wishlistRegisteredEmails') || '[]');
    if (user?.email && registeredEmails.includes(user.email)) {
      setIsRegistered(true);
    }
  }, [user?.email]);

  // Prevent to stay at the bottom of the screen when coming from share
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleWishlistSignup = async () => {
    try {
      const result = await createWishlistSignup(user?.email);

      if ('data' in result) {
        // Save email to localStorage to remember user is registered
        const registeredEmails = JSON.parse(localStorage.getItem('wishlistRegisteredEmails') || '[]');
        if (!registeredEmails.includes(user?.email)) {
          registeredEmails.push(user.email);
          localStorage.setItem('wishlistRegisteredEmails', JSON.stringify(registeredEmails));
        }
        setIsRegistered(true);
        openWishlistModal();
      } else {
        // Handle API errors (like 404 when backend endpoint doesn't exist yet)
        if (result.error?.originalStatus === 404) {
          console.warn('Wishlist endpoint not implemented yet, showing success modal anyway');
          // For now, simulate success since backend isn't ready
          const registeredEmails = JSON.parse(localStorage.getItem('wishlistRegisteredEmails') || '[]');
          if (!registeredEmails.includes(user?.email)) {
            registeredEmails.push(user.email);
            localStorage.setItem('wishlistRegisteredEmails', JSON.stringify(registeredEmails));
          }
          setIsRegistered(true);
          openWishlistModal();
        } else {
          console.error('Error signing up for wishlist:', result.error);
        }
      }
    } catch (error) {
      console.error('Error signing up for wishlist:', error);
    }
  };

  return (
    <div className='container flex flex-col gap-6 md:gap-10 py-8 lg:py-[60px]'>
      {percentageUsed > 90 && <AccountSuspension percentageUsed={percentageUsed} />}
      {/* <UploadButtons /> */}
      {!isRegistered && (
        <div className='flex justify-center mb-4'>
          <button
            className='flex items-center justify-center gap-2 bg-brand-gold text-black font-semibold px-4 py-2 rounded-lg hover:bg-opacity-90 transition-all w-[30%] md:w-[25%] min-w-fit disabled:opacity-50 disabled:cursor-not-allowed'
            onClick={handleWishlistSignup}
            disabled={isLoading}
          >
            <ChestLogo className='h-4 w-4 flex-shrink-0' />
            <span className='text-sm md:text-base'>{t('wishlist.button')}</span>
            {isLoading && (
              <div className='animate-spin h-4 w-4 border-2 border-black border-t-transparent rounded-full'></div>
            )}
          </button>
        </div>
      )}
      <Uploader />
      <Chest />
    </div>
  );
}